<template>
  <div>
    <div style="margin: 0 0 24px 180px;">
      <el-checkbox-group v-model="checkList" style="padding-top:0px;">
        <div><el-checkbox size="large" :label="1">手持正面照</el-checkbox></div>
        <div><el-checkbox size="large" :label="2">身份证正面照</el-checkbox></div>
      </el-checkbox-group>
      <div><el-checkbox size="large" v-model="regAgain">重复注册</el-checkbox></div>
      <div><el-checkbox v-model="isNonage">未成年用户</el-checkbox></div>
    </div>
    <div class="dialog-footer" style="text-align: center;">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="identitySub" v-loading="identitySubLoading">发送 & 不通过</el-button>
    </div>
  </div>
</template>

<script>
import { postFormData } from "@/api/api"
import { updateIdentityState } from "@/api/url";
export default {
  name: "IdentityRejectDialog",
  props: {
    value: Object
  },
  data() {
    return {
      idArray: this.value.idArray,
      checkList:[1,2],
      regAgain: false,
      identitySubLoading: false,
      state: 1,
      isNonage: false,
    }
  },
  methods: {

    cancel() {
      this.$emit("close");
    },
    identitySub() {
      if(this.checkList.length == 0){
        this.$message({
          showClose: true,
          duration: 1000,
          message: '至少选择一个照片类型',
          type: 'warning'
        })
        return false
      }
      if(this.checkList.length == 2 || this.isNonage){
        this.state = 3;
      }else if(this.checkList[0] == 1){
        this.state = 4;
      }else if(this.checkList[0] == 2){
        this.state = 5;
      }
      this.identitySubLoading = true;
      let _this = this;
      let param = {};
      param['idArr'] = this.idArray;
      param['state'] = this.state;
      if(this.regAgain) {
        param['isRepeat']  = 1;
      }else{
        param['isRepeat']  = 0;
      }
      postFormData(updateIdentityState,param).then(function(data){
        let {code,msg} = data;
        if(code == 200){
          _this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'success'
          });
          _this.$emit('confirm');
        }else{
          _this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        _this.identitySubLoading = false;
      })
              .catch(function(response){
                _this.identitySubLoading = false;
              })
    }
  }
}
</script>

<style scoped>

</style>
